import { render, staticRenderFns } from "./hotelserviceList.vue?vue&type=template&id=19ea423c&scoped=true"
import script from "./hotelserviceList.vue?vue&type=script&lang=js"
export * from "./hotelserviceList.vue?vue&type=script&lang=js"
import style0 from "./hotelserviceList.vue?vue&type=style&index=0&id=19ea423c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea423c",
  null
  
)

export default component.exports